module.exports = __webpack_public_path__ + "static/media/about-left.f026570b.png";